export var BillSlipStatus;
(function (BillSlipStatus) {
    BillSlipStatus["Verified"] = "VERIFIED";
    BillSlipStatus["Pending"] = "PENDING";
    BillSlipStatus["Rejected"] = "REJECTED";
})(BillSlipStatus || (BillSlipStatus = {}));
//# sourceMappingURL=bill-slip-status.enum.js.map